import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "./chat_demo.js"
import "./announcement.js"
import "./heading_anchors.js"
import "./product_update_filter.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
